<template>
  <!-- <div :id="idgpbutton"></div> -->
  <div>
    <v-btn
      v-if="showGPay"
      outlined
      aria-label="Google Pay"
      :class="{
        'gpay-button': true,
        white: !isDark,
        black: isDark,
        short: true,
      }"
      @click="onGooglePaymentsButtonClicked"
    >
    </v-btn>
  </div>
</template>
<script>
const baseCardPaymentMethod = {
  type: "CARD",
  parameters: {
    allowedCardNetworks: ["VISA", "MASTERCARD"],
    allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
  },
};

const googlePayBaseConfiguration = {
  apiVersion: 2,
  apiVersionMinor: 0,
  allowedPaymentMethods: [baseCardPaymentMethod],
};
export default {
  name: "GPayButton",
  components: {},
  props: ["price", "currencyCode", "isDark"],
  data: function() {
    return {
      googlePayClient: null,
      idgpbutton: "gpbutton",
      showGPay: false,
    };
  },

  methods: {
    showButton() {
      this.googlePayClient = new google.payments.api.PaymentsClient({
        environment: "TEST",
      });
      var that = this;
      this.googlePayClient
        .isReadyToPay(googlePayBaseConfiguration)
        .then(function(response) {
          if (response.result) {
            that.createAndAddButton();
          } else {
            alert("Unable to pay using Google Pay");
          }
        })
        .catch(function(err) {
          console.error("Error determining readiness to use Google Pay: ", err);
        });
    },
    createAndAddButton() {
      const googlePayButton = this.googlePayClient.createButton({
        // currently defaults to black if default or omitted
        buttonColor: "black",
        // defaults to long if omitted
        buttonType: "short",
        onClick: this.onGooglePaymentsButtonClicked,
      });
      this.showGPay = true;
    },
    onGooglePaymentsButtonClicked() {
      // TODO: Perform transaction
      const tokenizationSpecification = {
        type: "PAYMENT_GATEWAY",
        parameters: {
          gateway: "example",
          gatewayMerchantId: "gatewayMerchantId",
        },
      };
      const cardPaymentMethod = {
        type: "CARD",
        tokenizationSpecification: tokenizationSpecification,
        parameters: {
          allowedCardNetworks: ["VISA", "MASTERCARD"],
          allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
          billingAddressRequired: true,
          billingAddressParameters: {
            format: "FULL",
            phoneNumberRequired: true,
          },
        },
      };
      const merchantInfo = {
        // merchantId: '01234567890123456789', Only in PRODUCTION
        merchantName: "Example Merchant Name",
      };
      const transactionInfo = {
        totalPriceStatus: "FINAL",
        totalPrice: String(this.price),
        currencyCode: this.currencyCode,
      };
      const paymentDataRequest = Object.assign({}, googlePayBaseConfiguration, {
        allowedPaymentMethods: [cardPaymentMethod],
        transactionInfo: transactionInfo,
        merchantInfo: merchantInfo,
      });
      this.googlePayClient
        .loadPaymentData(paymentDataRequest)
        .then(function(paymentData) {
          processPayment(paymentData);
        })
        .catch(function(err) {
          // Log error: { statusCode: CANCELED || DEVELOPER_ERROR }
        });
    },
  },
  mounted() {
    this.showButton();
  },
};
</script>
>
